import { mapTaskFields } from '@/adapters/tasks'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'

export default async function getTasks({
  locale = 'ru-RU',
}: {
  locale?: string
} = {}) {
  const collectionName = 'tasks'

  const filter = {
    translations: { languages_code: { _eq: locale } },
  }

  try {
    const itemsRaw = await directusClient.request<Directus.Task[]>(
      readItems(collectionName, {
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
        },
        fields: [
          {
            translations: ['title'],
            image: imageFields,
          },
        ],
      })
    )

    const items = itemsRaw?.map(item => {
      return mapTaskFields(item)
    })

    return items
  } catch (error) {
    return []
  }
}
